import axios from 'axios';

const requestHandler = request => {
  request.requestStartTime = Date.now();
  return request;
};

const errorHandler = error => {
  if (error?.response?.status === 404) {
    return Promise.reject(error.response);
  }
  return Promise.reject(error);
};

const successHandler = response => {
  const requestTime = Date.now() - response.config.requestStartTime;
  return response;
};

const customAxios = () => {
  const instance = axios.create({
    headers: {
      Accept         : 'application/json',
      Authorization  : `Basic ${process.env.VUE_APP_APPLICATION_CREDENTIALS}`,
      'Content-Type' : 'application/json'
    },
    maxContentLength : 50000000000000,
    maxBodyLength    : 5000000000000000,
    baseURL          : process.env.VUE_APP_CREATOR_URL
  });

  instance.interceptors.request.use(request => requestHandler(request));

  instance.interceptors.response.use(
    response => successHandler(response),
    error => errorHandler(error)
  );
  return instance;
};

export default customAxios;
